import {ControlType, SplitType} from 'providers/SplitProvider';

export const getBearing = (start: {lat: number; lng: number}, end: {lat: number; lng: number}) => {
  const lat1 = (start.lat * Math.PI) / 180;
  const lat2 = (end.lat * Math.PI) / 180;
  const dLng = ((end.lng - start.lng) * Math.PI) / 180;
  const y = Math.sin(dLng) * Math.cos(lat2);
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
};

export const calculateSplits = (checkpoints: ControlType[]): SplitType[] => {
  const splits: SplitType[] = [];
  for (let i = 1; i < checkpoints.length; i++) {
    splits[i - 1] = {
      firstControl: checkpoints[i - 1],
      secondControl: checkpoints[i]
    };
  }
  return splits;
};
